export * from './api';
export {
  newVehicleGeneratedApi,
  type AuthorConfiguratorBundleResponseBody,
  type ColourResponseBody,
  type ColourWriteRequestBody,
  type EngineResponseBody,
  type EvaluateAuthorConfigurationApiArg,
  type FeatureResponseBody,
  type FeatureRuleResponseBody,
  type FeatureRuleWriteRequestBody,
  type FeatureWriteRequestBody,
  type ImporterPriceListBody,
  type MakeResponseBody,
  type ModelResponseBody,
  type ModelYearReadinessCheckResponseBody,
  type ModelYearReadinessResponseBody,
  type ModelYearReadinessSeverity,
  type ModelYearResponseBody,
  type OfferedTrimRequestBody,
  type OfferedTrimResponseBody,
  type PackageResponseBody,
  type PackageWriteRequestBody,
  type PricedItemArchiveRequestBody,
  type PricedItemBatchOperation,
  type PricedItemChangeBatchRequestBody,
  type PricedItemChangeBatchResponseBody,
  type PricelistVersionChangeResponseBody,
  type PricelistVersionRequestBody,
  type PricelistVersionHistoryItemResponseBody,
  type PriceAdjustmentRequestBody,
  type PriceAdjustmentResponseBody,
  type TrimResponseBody,
  type TrimWriteRequestBody,
  type UpholsteryResponseBody,
  type UpholsteryWriteRequestBody,
  type VariantResponseBody,
} from './codegen/__generated__/api.generated';
export type {VatRateType} from '@dms/api/shared';
export type * from './types';
export * from './getManualStatusTargets';
